const config = require('config/index');

const env = config.EnvConfig;
const backendUrl = env.server;

export default link => {
    let isExternalUrl;
    const linkProps = {};

    try {
        const baseUrlObj = new URL(backendUrl);
        const urlObj = new URL(link, baseUrlObj);
        isExternalUrl = baseUrlObj.host !== urlObj.host;

        if (isExternalUrl) {
            linkProps['href'] = link;
        } else {
            linkProps['href'] = urlObj.pathname;
        }
    } catch (e) {
        linkProps['href'] = link;
    }

    return linkProps;
};
